import React, { useState, useEffect } from "react";
import { DASHBOARD_CLIENT_OVERVIEW } from "../../Configuration/API_URL";
import whatsAppIcon from "../../asset/images/whatsapp-icon.svg";
import phoneIcon from "../../asset/images/phone-icon.svg";
import EditImg from "../../asset/images/edit.svg";
import ProfileL from "../../asset/images/rish.png";
import Loader from "../Common/Loader";
import SmallLoader from "../Common/smallLoader";
import {
  checkBoolean,
  checkString,
  mobileNumber,
  splitDateSlash,
  splitYear,
} from "../../CommonMethhods/CommonMethods";
import { Constants } from "../../CommonMethhods/Constants";

function ClientProfileCard(props) {
  // const storeToken = localStorage.getItem("ssoToken")
  // const [basicDetails, setbasicDetails] = useState();
  let basicDetails = props.basicDetails;
  const loader = props.loader;
  // console.log(basicDetails, "basic details");
console.log("basic details", basicDetails)
  const fullDate =
    basicDetails === undefined || null
      ? "NA"
      : checkString(basicDetails.createdDt);

  function addressArray(array) {
    let a = "";
    array.forEach((item) => {
      if (item.length > 0) {
        if (item != " " && item != "NA") a = a + item + ",";
      }
    });

    return a.length > 0 ? a : "NA";
  }

  // setFirst()

  const fullDateFinal = splitDateSlash(fullDate);

  const formOk =
    basicDetails === undefined || null
      ? false
      : checkString(basicDetails.formok);

  const poaRecieve =
    basicDetails === undefined || null ? false : checkString(basicDetails.poa);

  const cvlVerify =
    basicDetails === undefined || null || ""
      ? false
      : checkString(basicDetails.cvlVerified);

  const Address1 =
    basicDetails === undefined || null
      ? "NA"
      : checkString(basicDetails.addressdtls.address1);

  const Address2 =
    basicDetails === undefined || null
      ? "NA"
      : checkString(basicDetails.addressdtls.address2);

  const Address3 =
    basicDetails === undefined || null
      ? "NA"
      : checkString(basicDetails.addressdtls.address3);

  const State =
    basicDetails === undefined || null
      ? "NA"
      : checkString(basicDetails.addressdtls.state);

  const City =
    basicDetails === undefined || null
      ? "NA"
      : checkString(basicDetails.addressdtls.city);

  const Zip =
    basicDetails === undefined || null
      ? "NA"
      : checkString(basicDetails.addressdtls.zip);

  const GetFName =
    basicDetails === undefined || null
      ? " "
      : basicDetails.fName === undefined || null
      ? " "
      : basicDetails.fName;

  const GetMName =
    basicDetails === undefined || null
      ? " "
      : basicDetails.mName === undefined || null
      ? " "
      : basicDetails.mName;

  const GetLName =
    basicDetails === undefined || null
      ? " "
      : basicDetails.lName === undefined || null
      ? " "
      : basicDetails.lName;

  let firstName = GetFName.charAt(0);
  let lastName = GetLName.charAt(0);
  return (
    <>
      <div className="user-profile card-box">
        {/* {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : ( */}
        <div>
          <div className="user-profile__top">
            <div className="profile__details d-flex">
              {/* <!-- profile image --> */}

              <div className="profile__img">
                {/* <img className="profile-pic" src={ProfileL} alt="User Profile Icon" /> */}

                {basicDetails === undefined || null ? (
                  <h2 className="profile-img-name">NA</h2>
                ) : basicDetails.profilePic === undefined || null || " " ? (
                  <h2 className="profile-img-name">{firstName + lastName}</h2>
                ) : (
                  <img
                    className="profile-pic"
                    src={basicDetails.profilePic}
                    alt="User Profile Icon"
                  />
                )}

                {/* <img className="edit-icon" src={EditImg} alt="Edit icon" /> */}
              </div>
              <div className="profile__details__wrapper">
                {/* <!-- user name and joining details --> */}
                <div className="user__details">
                  <div>
                    {loader ? (
                      // <div className="loader-alignment justify-content-start">
                      <SmallLoader />
                    ) : (
                      // </div>
                      <h3 className="user__details__name">
                        {GetFName + " " + GetMName + " " + GetLName}
                      </h3>
                    )}

                    <h5 className="client-since">
                      {Constants.Client_since}
                      {fullDateFinal === undefined || null || ""
                        ? "NA"
                        : fullDateFinal}
                    </h5>
                  </div>
                  {/* <div className="social-icons d-flex">
                    <a className="phone-icon icon">
                      <img src={phoneIcon} alt="Phone Icon" />
                    </a>
                    <a className="whatsapp-icon icon">
                      <img src={whatsAppIcon} alt="whatsapp Icon" />
                    </a>
                  </div> */}
                </div>
                {/* <!-- status of user --> */}
                <div className="user-status">
                  <div className="status-left">
                    <button className="client-status blue-status">
                      {/* BFSL07 */}
                      {basicDetails === undefined || null || ""
                        ? "NA"
                        : checkString(basicDetails.clientCode)}
                    </button>
                    {console.log(basicDetails?.activeStatus, "statusCheck")}

                    <button
                      className={
                        basicDetails?.activeStatus == "ACTIVE"
                          ? "client-status green-status ml-3"
                          : basicDetails?.activeStatus == "INACTIVE" ?
                          "client-status yellow-status ml-3"
                          : basicDetails?.activeStatus == "CLOSED" ? "client-status red-status ml-3"
                          : "client-status blue-status ml-3"
                      }
                    >
                      {/* BFSL07 */}
                      {basicDetails === undefined || null || ""
                        ? "NA"
                        : checkString(basicDetails.activeStatus)}
                    </button>
                  </div>

                  <div className="status-right">
                    <button className="client-status">
                    {basicDetails === undefined || null
                      ? "NA"
                      : basicDetails?.cvlVerified}
                  </button>
                    {/* <button className="client-status purple-status">
                      {basicDetails === undefined || null
                        ? "NA"
                        : checkBoolean(basicDetails.formok)
                        ? "Form-ok"
                        : "Form-Not-Ok"}
                    </button> */}
                    <button className="client-status purple-status">
                      {basicDetails === undefined || null
                        ? "NA"
                        : checkString(basicDetails.ddpi)}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="user-profile__bottom row">
            <div className="col-12 col-md-6 contact">
              <p className="contact-number contact__details">
                <span className="icon-phone-icon"> </span>
                {loader ? (
                  // <div className="loader-alignment">
                  <SmallLoader />
                ) : // </div>
                basicDetails === undefined || null ? (
                  "NA"
                ) : (
                  checkString(basicDetails.mobno)
                )}
              </p>

              <p className="email contact__details">
                <span className="icon-email"></span>
                {loader ? (
                  // <div className="loader-alignment">
                  <SmallLoader />
                ) : // </div>
                basicDetails === undefined || null ? (
                  "NA"
                ) : (
                  checkString(basicDetails.emailid)
                )}
              </p>
              <p className="location contact__details">
                <span className="icon-location"></span>
                {/* {Address1+","+Address2+","+Address3+","+State+","+City+","+Zip} */}
                {loader ? (
                  // <div className="loader-alignment">
                  <SmallLoader />
                ) : (
                  // </div>
                  addressArray([Address1, Address2, Address3, State, City, Zip])
                )}
              </p>

              <p className="code contact__details">
                <span className="icon-id-card"></span>
                {/* SONKB0008H */}
                {loader ? (
                  // <div className="loader-alignment">
                  <SmallLoader />
                ) : // </div>
                basicDetails === undefined || null ? (
                  "NA"
                ) : (
                  mobileNumber(basicDetails.pan)
                )}
              </p>
            </div>
            <div className="col-12 col-md-6 contact-right">
              <div className="contact-right__top d-flex align-items-end">
                <div className="referred-by">
                  <p>
                    {Constants.Referred_By} <br />
                    {loader ? (
                      // <div className="loader-alignment justify-content-start">
                      <SmallLoader />
                    ) : (
                      // </div>
                      <span>
                        {/* Tarun Joshi */}

                        {basicDetails === undefined || null
                          ? "NA"
                          : checkString(basicDetails.ref)}
                      </span>
                    )}
                  </p>
                </div>
                {/* <div className="status-left">
                  <button className="client-status">
                    {basicDetails === undefined || null
                      ? "NA"
                      : basicDetails?.cvlVerified}
                  </button>
                </div> */}
              </div>
              <ul className="contact-right__bottom">
                {/* <li className="referrence-details">{Constants.Brokerage}</li>
                <li className="referrence-details">64732243,32 L</li> */}
                <li className="referrence-details">
                  {Constants.Sales_Employee_Code}
                </li>
                <li className="referrence-details">
                  {/* RZM8001 */}
                  {loader ? (
                    // <div className="loader-alignment">
                    <SmallLoader />
                  ) : // </div>
                  basicDetails === undefined || null ? (
                    "NA"
                  ) : (
                    checkString(basicDetails.empcode)
                  )}
                </li>

                {/* <li className="referrence-details">{Constants.Assignee}</li>
                <li className="referrence-details">
                  
                  {loader ? (
                 
                    <SmallLoader />
                  ) : 
                    basicDetails === undefined || null || "" ? (
                      "NA"
                    ) : (
                      checkString(basicDetails.assignee)
                    )}
                </li> */}

                <li className="referrence-details">{Constants.Lead_Source}</li>
                <li className="referrence-details">
                  {loader ? (
                    // <div className="loader-alignment">
                    <SmallLoader />
                  ) : // </div>
                  basicDetails === undefined || null ? (
                    "NA"
                  ) : (
                    checkString(basicDetails.leadsrc)
                  )}
                </li>
                <li className="referrence-details">Dealer Code</li>
                <li className="referrence-details">
                  {loader ? (
                    <SmallLoader />
                  ) :
                  basicDetails === undefined || null ? (
                    "NA"
                  ) : (
                    checkString(basicDetails?.dealerCode)
                  )}
                </li>
                <li className="referrence-details">Dealer Name</li>
                <li className="referrence-details">
                  {loader ? (
                    <SmallLoader />
                  ) :
                  basicDetails === undefined || null ? (
                    "NA"
                  ) : (
                    checkString(basicDetails?.dealerName)
                  )}
                </li>
              </ul>
            </div>
          </div>
        </div>
        {/* )} */}
      </div>
    </>
  );
}

export default ClientProfileCard;
